<mat-card *ngIf="user && answerControl.length > 0">
  <mat-card-header *ngIf="!router.url.includes('preview')">
    <mat-card-title>
      <h1>
        <span class="form-name">{{form.form}}</span> |
        {{countryOrSystemName}}
        <app-help-icon-button [code]="'answerforms.detail'"></app-help-icon-button>
      </h1>
    </mat-card-title>
    <mat-card-subtitle>
      <h3>Year - <span class="form-name">{{form.year}}</span></h3>
      <h3>Total Categories - <span class="form-name">{{categoriesWithQuestions.length}}</span></h3>
      <h3>Questions - <span class="form-name">{{form.questions}}</span></h3>
      <h3 *ngIf="form && formAnswers">Unanswered - <span class="form-name">{{form.questions - formAnswers.length}}</span></h3>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-header *ngIf="router.url.includes('preview')">
    <mat-card-title>
      <h1>
        <span class="form-name">Preview</span>
      </h1>
    </mat-card-title>
    <mat-card-subtitle>
      <h3>Year - <span class="form-name">{{yearPreview}}</span></h3>
      <h3>Total Categories - <span class="form-name">{{categoriesWithQuestions.length}}</span></h3>
      <h3>Questions - <span class="form-name">{{questions.length}}</span></h3>
      <h3>Unanswered - <span class="form-name">{{questions.length}}</span></h3>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group dynamicHeight (selectedIndexChange)="groupIndex = $event">
      <mat-tab class="roq-categories-label" *ngFor="let category of categoriesWithQuestions">
        <ng-template mat-tab-label>
          <span matBadge="{{unansweredMap?.get(category.description)}}"
                matBadgeOverlap="false">{{category.description}}</span>
        </ng-template>
        <div class="tab-body" *ngFor="let question of questions; index as i">
          <div *ngIf="category.id === question.category.id">
            <form class="form-search-bar" [formGroup]="answerForm" autocomplete="off">
              <div formArrayName="answers">
                <h2><span>{{question.description}}</span><span
                  matTooltip="{{question.mandatory ? 'Mandatory question' : ''}}"
                  class="required-asterisk">{{question.mandatory ? ' *' : ''}}</span></h2>
                <p>{{question.comment}}</p>

                <mat-form-field appearance="fill" class="filter-item" [formGroupName]="i"
                                *ngIf="question.answerType === 'TEXT'">
                  <mat-label>{{'intelligence-reporting.questions.answer' |translate}}</mat-label>
                  <input matInput type="text" formControlName="answer" (change)="markAsCompletedAvailable = true; answerControl.at(i).get('reasonUnanswered')?.setValue(null)">
                  <mat-error *ngIf="answerControl.at(i).get('answer')?.hasError('maxlength')">
                    {{'The maximum length is ' + answerControl.at(i).get('answer')?.getError('maxlength').requiredLength}}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="filter-item" [formGroupName]="i"
                                *ngIf="question.answerType === 'NUMBER'">
                  <mat-label>{{'intelligence-reporting.questions.answer' |translate}}</mat-label>
                  <input matInput type="number" formControlName="answer" (change)="markAsCompletedAvailable = true; answerControl.at(i).get('reasonUnanswered')?.setValue(null)">
                  <mat-error *ngIf="answerControl.at(i).get('answer')?.hasError('min')">
                    {{'The minimum value is ' + answerControl.at(i).get('answer')?.getError('min').min}}
                  </mat-error>
                  <mat-error *ngIf="answerControl.at(i).get('answer')?.hasError('max')">
                    {{'The maximum value is ' + answerControl.at(i).get('answer')?.getError('max').max}}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="filter-item" [formGroupName]="i"
                                *ngIf="question.answerType === 'BOOLEAN'">
                  <mat-label>{{'intelligence-reporting.questions.answer' |translate}}</mat-label>
                  <mat-select formControlName="answer" (selectionChange)="markAsCompletedAvailable = true; answerControl.at(i).get('reasonUnanswered')?.setValue(null)">
                    <mat-option [value]="">-</mat-option>
                    <mat-option [value]="'true'">Yes</mat-option>
                    <mat-option [value]="'false'">No</mat-option>
                  </mat-select>
                </mat-form-field>


<!--                <p *ngIf="question.answerType === 'LIST'">{{availableAnswers[i] | json}}</p>-->
<!--                <p>{{answerControl.controls[i].value.answer}}</p>-->

                <mat-form-field appearance="fill" class="filter-item" [formGroupName]="i"
                                *ngIf="question.answerType === 'LIST'">
                  <mat-label>{{'intelligence-reporting.questions.answer' |translate}}</mat-label>
                  <mat-select formControlName="answer" [multiple]="question.multiSelect"
                              (selectionChange)="markAsCompletedAvailable = true; answerControl.at(i).get('reasonUnanswered')?.setValue(null)">
                    <mat-option *ngFor="let a of availableAnswers[i]" [value]="a">{{a}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="filter-item" [formGroupName]="i">
                  <mat-label>{{'intelligence-reporting.questions.sharing-level' | translate}}</mat-label>
                  <mat-select formControlName="sharingLevel">
                    <mat-option *ngFor="let sl of sharingLevel" [value]="sl.value">{{sl.description}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="filter-item" [formGroupName]="i" *ngIf="question.mandatory">
                  <mat-label>{{'intelligence-data-entry.reason' | translate}} {{'intelligence-data-entry.unanswered' | translate}}</mat-label>
                  <mat-select formControlName="reasonUnanswered" (selectionChange)="removeRequired(i, true)">
                    <mat-option [value]="null">-</mat-option>
                    <mat-option *ngFor="let ur of reasonUnanswered" [value]="ur.value">{{ur.description}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="last-year-button" *ngIf="lastYearAnswers && lastYearAnswers[i] !== null">
                  <button mat-raised-button type="button" color="primary" (click)="setLastYearAnswer(i)">
                    <mat-icon>restore</mat-icon> <!-- restore, undo -->
                    <span> Last Year Answer</span>
                  </button>
                </div>
              </div>
            </form>
            <mat-divider></mat-divider>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="warning" *ngIf="answerForm.invalid && !router.url.includes('preview')">
      <mat-icon>warning</mat-icon>
      <span class="warning-text"> Answer is missing for obligatory questions marked with asterix in one or more questions categories. If you do not wish to answer, please provide a reason.</span>
    </div>

    <div class="answer-buttons-container" *ngIf="groupIndex !== null">
      <button mat-raised-button type="button"
              (click)="cancel()">
        <span>Cancel</span>
      </button>
      <button mat-raised-button type="button" *ngIf="groupIndex > 0"
              (click)=" group.selectedIndex !== null && group.selectedIndex !== undefined
              ? group.selectedIndex = group.selectedIndex - 1
              : null; groupIndex = groupIndex - 1">
        <span>Back</span>
      </button>
      <button mat-raised-button color="primary" type="button" *ngIf="groupIndex < categoriesWithQuestions.length - 1"
              (click)=" group.selectedIndex !== null && group.selectedIndex !== undefined
              ? group.selectedIndex = group.selectedIndex + 1
              : null; groupIndex = groupIndex + 1">
        <span>Next</span>
      </button>
      <button mat-raised-button color="primary" type="button" *ngIf="!router.url.includes('preview')"
              [disabled]="answerForm.invalid && this.form.status === 'Completed'"
              (click)="saveAnswer()">
        <span>Save</span>
      </button>
      <button *ngIf="formAnswers && !formAnswers[0]?.completed" mat-raised-button color="primary" type="button"
              [disabled]="answerForm.invalid"
              (click)="!answerForm.invalid ? saveAnswer(true) : ''">
        <span>Mark As Completed</span>
      </button>
    </div>
  </mat-card-content>
</mat-card>
